import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const FAQ = () => {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Al completar el pago recibís un email con el acceso inmediato a todos los PDFs. Los descargás en tu celular, tablet o computadora y los abrís en Gamma App o en cualquier visor de PDF. Acceso en menos de 5 minutos.'
  }, {
    q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
    a: 'Sí para los dos. Si sos nuevo, el sistema te da la estructura que necesitás para dar clases con confianza desde el primer día. Si tenés experiencia, te da la herramienta para profesionalizar lo que ya sabés y mostrar resultados concretos a los padres.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones de packs?',
    a: 'Sí. Los 6 Bonus estratégicos están incluidos en el Pack Niños, en el Pack Adultos y en el Megapack Élite sin costo extra.'
  }, {
    q: '¿Qué diferencia hay con otros materiales que ya existen?',
    a: 'PATÍN 360 es el único sistema diseñado específicamente para el profe de patín artístico argentino, con ejercicios graficados en formato A4 listos para usar en la pista, planillas de seguimiento y una progresión técnica clara de nivel inicial a avanzado. No es un libro para leer. Es una herramienta de pista para usar mañana.'
  }, {
    q: '¿Sirve para distintos niveles mezclados en el mismo grupo?',
    a: 'Sí. El Bonus 1 "Pista Libre" está diseñado específicamente para esto. Te enseña el sistema de estaciones para manejar 3 niveles distintos en una sola hora de clase sin que nadie se aburra.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si abrís el material y no es lo que esperabas, te devolvemos el 100% del dinero. Sin preguntas. Sin formularios. Sin drama.'
  }, {
    q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
    a: 'Sí. El Megapack Élite agrega la Planificación Anual 360 (tu calendario de 40 semanas resuelto) y el Acelerador Axel (la clínica técnica definitiva del salto más importante del patín artístico). Si ya planificás bien, estos dos ebooks van a llevar tu enseñanza al siguiente nivel.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, y también transferencia bancaria. El proceso de pago es 100% seguro.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-gray-50" data-id="element-57">
      <div className="max-w-3xl mx-auto px-4" data-id="element-58">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-59">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-60">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-61">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-62">
                <span className="font-bold text-gray-900 pr-4" data-id="element-63">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-600 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-64" />
              </button>
              <AnimatePresence data-id="element-65">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-66">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-67">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};